import { useEffect } from "react";
import { LOGIN_CALLBACK_ROUTE } from "../constants";
import { useAuth0 } from "@auth0/auth0-react";

export const CheckAuthHoc = (WrappedComponent, { apiHost, basePath = "", Loader }) => {
  function WrappingComponent(props) {
    const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
    const authenticated = !isLoading && isAuthenticated;
    useEffect(() => {
      if (isLoading) {
        return;
      }

      if (!isAuthenticated) {
        loginWithRedirect({
          redirectUri: window.location.origin + basePath + LOGIN_CALLBACK_ROUTE,
          appState: { returnTo: window.location.pathname + window.location.search },
          apiHost,
        });
      }
    }, [isAuthenticated, isLoading, loginWithRedirect]);

    return authenticated ? <WrappedComponent {...props} /> : <Loader />;
  }

  return WrappingComponent;
};
